import { useTranslation } from 'react-i18next';

export default function PageLoader() {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gold mx-auto mb-4"></div>
        <p className="text-gray-400 text-sm">{t('pageLoader.loading')}</p>
      </div>
    </div>
  );
}
